export default __webpack_public_path__ + "static/media/insta.37d6d662.svg";